import styled, { css } from 'styled-components'
import Colors from '../constants/colors'
import { BlogThreshold as Threshold } from '../constants/theme'

export const BlogContent = styled.section`
  box-sizing: border-box;
  width: 100vw;
  margin-top: 20px;
  
  ${p => p.promoId && css`
      .infiniteScroll article[data-post-id="${p.promoId}"] {
        display: none;
      }
  `}
`

export const BlogTitle = styled.h2`
  display: flex;
  width: 100%;
  margin: 25px 0;
  margin-top: 50px;
  
  font-size: 50px;
  line-height: 1.2;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  
  ::after {
    content: '';
    border-top: 4px solid ${Colors.primary};
    margin-left: 40px;
    flex: 1 0 0;
  }
  
  @media (max-width: ${Threshold.tablet}) {
    ${props => !props.showBig && css`font-size: 20px;`}
    ${props => props.showBig && css`margin-top: 20px;`}
    line-height: 1.5;
    
    ::after {
      margin-left: 20px;
    }
  }
  
  @media (max-width: ${Threshold.phone}) {
    letter-spacing: 1px;
    font-size: 20px;
    
    ::after {
      display: none;
    }
  }
`

export const SubTitle = styled(BlogTitle)`
  padding-left: 40px;
  padding-right: 20px;
  font-size: 20px;
  
  @media (max-width: ${Threshold.tablet}) {
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 12px;
    padding: 0;
    padding-top: 37px;
    ${p => p.showBorder && css`border-top: 1px solid #d2dae4;`}
    
    ::after {
      display: none;
    }
    
  }
  
  @media (max-width: ${Threshold.phone}) {
    justify-content: flex-start;
    font-size: 14px;
    line-height: 1.57;
  }
`

export const AuthorsList = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -25px;
`
